// =============================================================================
//  pdfViewer — registre du viewer PDF in-app (drawer global).
//
//  openInvoicePdf (lib, hors React) ne peut pas rendre un composant : le
//  drawer PdfViewerHost, monté une fois dans App, s'enregistre ici à son
//  mount. showPdfInViewer renvoie false tant qu'aucun hôte n'est monté —
//  l'appelant retombe alors sur window.open (tests, contexte sans UI).
// =============================================================================

export interface PdfViewerRequest {
  /** URL affichable dans une iframe (URL signée storage, blob:, …). */
  url: string
  /** Titre lisible dans l'en-tête du drawer (ex : n° de facture). */
  title: string
}

type PdfViewerHandler = (req: PdfViewerRequest) => void

let handler: PdfViewerHandler | null = null

export function registerPdfViewer(h: PdfViewerHandler | null): void {
  handler = h
}

/** Affiche le PDF dans le drawer in-app ; false si aucun hôte n'est monté. */
export function showPdfInViewer(req: PdfViewerRequest): boolean {
  if (!handler) return false
  handler(req)
  return true
}

/** Aperçu in-app d'un PDF jsPDF fraîchement généré : ouvre le drawer viewer,
 *  jamais de téléchargement. Révoque l'URL blob précédente (un seul aperçu
 *  vivant à la fois). Retombe sur un onglet si aucun hôte n'est monté. */
let lastPreviewUrl: string | null = null
export function previewPdfInViewer(doc: { output: (type: 'blob') => Blob }, title: string): void {
  if (lastPreviewUrl) { URL.revokeObjectURL(lastPreviewUrl); lastPreviewUrl = null }
  const url = URL.createObjectURL(doc.output('blob'))
  lastPreviewUrl = url
  if (!showPdfInViewer({ url, title })) window.open(url, '_blank')
}
